const blocks = Array.from(document.querySelectorAll('.js-about-block'));
let blockTops = [];

function cacheBlockTops() {
  blockTops = blocks.map(block => block.offsetTop);
}

function handleScrollAll() {
  const scrollY = window.scrollY;
  const viewportHeight = window.innerHeight;
  const threshold = viewportHeight - 220;

  blocks.forEach((block, i) => {
    const inner = block.querySelector('.js-about-block-inner');

    if (inner) {
      const innerHeight = inner.offsetHeight;
      const maxParallax = Math.max(innerHeight - threshold, 0);
      const blockTopInDocument = blockTops[i]; 
      const scrollIntoBlock = scrollY - blockTopInDocument;

      if (innerHeight > threshold) {
        const translateY = Math.min(scrollIntoBlock, maxParallax);
        inner.style.transform = `translateY(-${translateY}px)`;
      }
    }
  });

  let activeIndex = 0;

  blockTops.forEach((top, i) => {
    if (scrollY >= top) {
      activeIndex = i;
    }
  });

  blocks.forEach((block, i) => {
    const nextBlock = blocks[i + 1];

    if (i < activeIndex) {
      block.style.transform = 'scale(0.9)';
      block.style.opacity = '0';
      return;
    }

    if (i === activeIndex && nextBlock) {
      const nextRect = nextBlock.getBoundingClientRect();
      const triggerPoint = viewportHeight * 0.9;

      const progress = 1 - (nextRect.top / triggerPoint);
      const clamped = Math.min(Math.max(progress, 0), 1);

      const scale = 1 - 0.1 * clamped;
      const opacity = 1 - clamped;

      block.style.transform = `scale(${scale})`;
      block.style.opacity = opacity.toFixed(3);
      return;
    }

    block.style.transform = 'scale(1)';
    block.style.opacity = '1';
  });
}

window.addEventListener('scroll', handleScrollAll);
window.addEventListener('resize', () => {
  cacheBlockTops();
  handleScrollAll();
});
window.addEventListener('load', () => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (typeof lenis !== 'undefined') {
        lenis.scrollTo(0, { immediate: true });
      } else {
        window.scrollTo(0, 0);
      }

      requestAnimationFrame(() => {
        cacheBlockTops();
        handleScrollAll();

        setTimeout(() => {
          blocks.forEach(block => block.classList.add('show'));
        }, 50);

        setTimeout(() => {
          blocks.forEach(block => block.classList.add('active'));
        }, 350);
      });
    });
  });
});